import humanFormat from 'human-format';
import type { NumericFormatProps } from 'react-number-format';
import { NumericFormat } from 'react-number-format';

// Medusa represents amounts in cents. Ex: 1099 = $10.99
export const toHumanFormat = (num: number) => {
  if (num < 100) {
    return num.toFixed(2); // Format to two decimal places
  }

  return humanFormat(num, {
    separator: '',
  });
};

export const toFloat = ({
  thousandSeparator = true,
  decimalScale = 2,
  fixedDecimalScale = true,
  ...numaricProps
}: NumericFormatProps) => (
  <NumericFormat
    {...numaricProps}
    fixedDecimalScale={fixedDecimalScale}
    decimalScale={decimalScale}
    thousandSeparator={thousandSeparator}
    customInput={(props: { value: string }) => <div className="text-medium">{props.value}</div>}
  />
);

export const toInteger = ({ thousandSeparator = true, ...numaricProps }: NumericFormatProps) => (
  <NumericFormat
    {...numaricProps}
    thousandSeparator={thousandSeparator}
    customInput={(props: { value: string }) => <div className="text-medium">{props.value}</div>}
  />
);
